import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import { Link } from "react-router-dom";
import { get, findIndex } from "lodash";
import { connect } from "react-redux";

import { CrudComponent, actionBtnTypes } from "../../../../../components/boda-boda/CRUD/CrudComponent";
import { FilterUI } from "./includes/FilterUI";
import { getOrdersListAPI } from "../../../../../config/boda-boda/apiUrls.config";
import { RemoveBtn, RemoveMessage } from "./includes/view-includes/DeleteUI";
import { RestoreBtn, RestoreUIMessage } from "./includes/view-includes/RestoreUI";
import { dateObjectToString } from "../../../../../helpers/boda-boda/common-helpers/dateTime.helpers";
import {
  customerNameShortHelperFn,
  formatToDateHelper,
  isEmptyValue
} from "../../../../../helpers/boda-boda/common-helpers/common.helpers";
import {mapOrderPaymentMethods} from "../../../../../config/boda-boda/db_config/db_status.config";
import { setFormErrorFn } from "../../../../../store/boda-boda/form/actions";


class PendingOrders extends Component {
  render() {
    let { history } = this.props;

    return (
      <React.Fragment>
        <div className="container-fluid">
          <Row className="align-items-center">
            <Col sm={6}>
              <div className="page-title-box">
                <h4 className="font-size-18">Pending Orders</h4>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to="#">Home</Link>
                  </li>
                  <li className="breadcrumb-item active">Pending Orders</li>
                </ol>
              </div>
            </Col>
          </Row>

          <Row>
            <CrudComponent
              title="Pending Orders"
              apiURL={`${getOrdersListAPI.url}?page=1&limit=20&status=PENDING`}
              dataTableStateKey={getOrdersListAPI.key}
              filterFromComponent={FilterUI}
              searchButtonOnTop={true}
              defaultFilterFormObject={{
                status: "PENDING",
                paymentMethod: "",
                deliveryType: "",
                phone: "",
                name: "",
                consignmentNo: "",
                trackingNumber: "",
                dateTo: null,
                dateFrom: null,
                channelOrderNo: "",
              }}
              clearErrors={() => {
                const { setFormErrorFn } = this.props;
                setFormErrorFn("ordersListAPIKey_search", [])
              }}
              onRebuildFilterObjFn={(filterData) => {
                const data = filterData;
                let { setFormErrorFn } = this.props;
                const errors = [];

                if (new Date(filterData.dateFrom) > new Date(filterData.dateTo)) {
                  errors.push({
                    "property":"dateTo",
                    "error":"The Date To field should not be less than the Date From field"
                  });
                }

                if(errors.length > 0 ){
                  setFormErrorFn("ordersListAPIKey_search", errors);
                  return ;
                }else{
                  setFormErrorFn("ordersListAPIKey_search", []);
                }

                if (!isEmptyValue(filterData.dateTo)) {
                  data["dateTo"] = formatToDateHelper(filterData.dateTo);
                }

                if (!isEmptyValue(filterData.dateFrom)) {
                  data["dateFrom"] = filterData.dateFrom.toISOString();
                }

                return data;
              }}
              isSetCreateAction={true}
              createActionProps={{
                actionType:actionBtnTypes.create,
                isSetModel:false,
                onClickBtnFn: () => history.push("/orders/pending/create")
              }}
              tableHeaderList={[
                { displayName: "Consignment No", key: "consignmentNo" },
                { displayName: "Tracking No", key: "trackingNumber", onPrintFn: (rawData) => (rawData.trackingNumber)? 
                <Link to={{ pathname: `${process.env.REACT_APP_BODA_CORPORATE_TRACK_BASE_URL}${rawData.trackingNumber}`}} target="_blank">{rawData.trackingNumber}</Link> :"-"
                },
                { displayName: "Customer Name", key: "name", onPrintFn: (rawData) => customerNameShortHelperFn(rawData.name)},
                { displayName: "Phone", key: "phone" },
                { displayName: "Delivery Type", key: "deliveryType" },
                { displayName: "Payment Method", key: "paymentMethod", onPrintFn: (rawData) => mapOrderPaymentMethods[rawData.paymentMethod] },
                { displayName: "Date", key: "createdAt", onPrintFn: (rawData) => dateObjectToString(rawData.createdAt)},
                { displayName: "Status", key: "status" },
              ]}
              actionList={[
                {
                  actionType: actionBtnTypes.view,
                  isSetModel: false,
                  actionBtn: {
                    onClickBtnFn: (rawData) => history.push(`/orders/pending/view/${rawData.id}`),
                  }
                },
                {
                  actionType:actionBtnTypes.edit,
                  isSetModel:false,
                  actionBtn: {
                    onClickBtnFn: (rawData) => history.push(`/orders/pending/edit/${rawData.id}`),
                  }
                },
                {
                  actionType: actionBtnTypes.other,
                  actionBtn: {
                    tooltip: "Cancel Order",
                    color: "danger",
                    icon: "far fa-times-circle",
                    btnText: "cancel",
                  },
                  isSetModel: true,
                  modalProps: {
                    modalTitle: "Please Confirm",
                    modalType: "",
                    modalBodyComponent: RemoveMessage,
                    modalFooterComponent: RemoveBtn,
                    isSetClose:true,
                    isSetFooterClose:true,
                    parentToModelProps: {
                      type: "datatable"
                    },
                    closeBtnName: "No"
                  },
                  checkBeforeActionRenderFn: (rawData) => {
                    if (rawData.rowData.status === "CANCELLED") {
                      return false;
                    }else if (get(rawData, "rowData.packages", []).length === 0) {
                      return true;
                    } else {
                      const check = findIndex(get(rawData, "rowData.packages", []), (element) => {
                        return element.manifestId !== null;
                      });

                      return check === -1;
                    }
                  }
                },
                {
                  actionType: actionBtnTypes.other,
                  actionBtn: {
                    tooltip: "Restore",
                    color: "success",
                    icon: "fas fa-redo",
                    btnText: "restore",
                  },
                  isSetModel: true,
                  modalProps: {
                    modalTitle: "Please Confirm",
                    modalType: "",
                    modalBodyComponent: RestoreUIMessage,
                    modalFooterComponent: RestoreBtn,
                    isSetClose:true,
                    isSetFooterClose:true,
                    parentToModelProps: {
                      type: "datatable"
                    },
                    closeBtnName: "No"
                  },
                  checkBeforeActionRenderFn: (rawData) => {
                    return rawData.rowData.status === "CANCELLED";
                  }
                }
              ]}
            />
          </Row>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    formState: state.FormData
  };
};

export default connect(mapStateToProps, {
  setFormErrorFn,
}) (PendingOrders);
